var map = {
	"./certificate.jpg": "2274",
	"./declare.jpg": "7b03",
	"./declare1.jpg": "0630",
	"./declare2.jpg": "7f44",
	"./experience.jpg": "2b97",
	"./graduate.jpg": "eae4",
	"./idCard.jpg": "eeb8",
	"./personCard.jpg": "6c66",
	"./social.jpg": "69de",
	"./xuexin.jpg": "4a30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d176";